export default {"src":"/planos/_next/static/media/equifax-shield-4.30dd1f37.svg","height":24,"width":19,"blurWidth":0,"blurHeight":0};